import { type MouseEvent as ReactMouseEvent } from "react";

import { Column, Text } from "@/components";

import { dashboardKpis } from "@/lib/dashboardKpis";
import { cn } from "@/lib/utils";
import { DashboardComparisonMetric } from "@/types";

// One staffer's column: their bar, their number, their first name. An unranked
// staffer (no screens to time) shows a dash and no bar rather than a zero.
export const StafferComparisonBar = ({
  barClassName,
  isRanked,
  metric,
  name,
  onHover,
  onHoverEnd,
  topPercent,
  value,
}: {
  barClassName: string;
  isRanked: boolean;
  metric: DashboardComparisonMetric;
  name: string;
  onHover: (event: ReactMouseEvent) => void;
  onHoverEnd: () => void;
  topPercent: number;
  value: number;
}) => (
  <Column
    className="relative min-w-0 cursor-default"
    onMouseEnter={onHover}
    onMouseLeave={onHoverEnd}
    onMouseMove={onHover}
  >
    {value > 0 ? (
      <Column
        className={cn(
          "absolute inset-x-0 bottom-0 min-h-0.5 rounded-t",
          barClassName,
        )}
        style={{ top: `${topPercent.toString()}%` }}
      />
    ) : null}
    <Text className="pointer-events-none absolute inset-x-0 bottom-5 z-30 truncate text-center text-[11px] font-medium tabular-nums leading-none text-slate-500">
      {isRanked ? dashboardKpis.formatCompactValue(metric, value) : "—"}
    </Text>
    <Text className="pointer-events-none absolute inset-x-0 bottom-1.5 z-30 truncate text-center font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-700">
      {name.split(" ")[0] || name}
    </Text>
  </Column>
);
